"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var header_main_row_component_1 = __importDefault(require("./header-main-row/header-main-row.component"));
var header_menu_component_1 = __importDefault(require("./header-menu/header-menu.component"));
var header_utility_nav_component_1 = __importDefault(require("./header-utility-nav/header-utility-nav.component"));
require("./index.css");
var HeaderV2 = function (props) {
  var _a = (0, react_1.useState)(false),
    isMobileMenuOpen = _a[0],
    setIsMobileMenuOpen = _a[1];
  var _b = (0, react_1.useState)(113),
    mobileMenuOffset = _b[0],
    setMobileMenuOffset = _b[1];
  return (0, jsx_runtime_1.jsxs)("header", __assign({
    className: (0, classnames_1.default)('rwc-header', {
      'rwc-header--mobile-menu-open': isMobileMenuOpen
    })
  }, {
    children: [(0, jsx_runtime_1.jsx)(header_utility_nav_component_1.default, __assign({}, props)), (0, jsx_runtime_1.jsx)(header_main_row_component_1.default, __assign({}, props, {
      isMobileMenuOpen: isMobileMenuOpen,
      setIsMobileMenuOpen: setIsMobileMenuOpen,
      mobileMenuOffset: mobileMenuOffset,
      setMobileMenuOffset: setMobileMenuOffset
    })), (0, jsx_runtime_1.jsx)(header_menu_component_1.default, __assign({}, props, {
      isMobileMenuOpen: isMobileMenuOpen,
      mobileMenuOffset: mobileMenuOffset,
      setIsMobileMenuOpen: setIsMobileMenuOpen
    }))]
  }));
};
exports.default = HeaderV2;